<p-confirmDialog key="addschooladdress" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="addschool1" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="addschool2" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="addschool3" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="addschoolresult" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--School Data-->
<div class="MainGrid">
	<h4 class="GridHeader">School Information</h4>

	<label>School ID:</label>
	<input
		[disabled]="IsLoading() == true"
		class="form-control InputWidth"
		type="number"
		min="1"
		placeholder="Unique Number (CANNOT BE CHANGED)"
		[(ngModel)]="SchoolID"
		(ngModelChange)="onSchoolIDChange($event)"
	/>

	<label>School Number:</label>
	<input
		[disabled]="IsLoading() == true"
		class="form-control InputWidth"
		type="text"
		placeholder="Alpha-Numeric Code displayed in CAASS (Can be changed later on)"
		[(ngModel)]="SchoolNumber"
	/>

	<label>School Name:</label>
	<input
		[disabled]="IsLoading() == true"
		class="form-control InputWidth"
		type="text"
		placeholder="Name of the school"
		[(ngModel)]="SchoolName"
		(ngModelChange)="onSchoolNameChange($event)"
	/>

	<label>School Type:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="SchoolTypeID" [(ngModel)]="SchoolTypeID">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstSchoolType" [ngValue]="o.SchoolTypeID">
			{{ o.SchoolTypeDesc }}
		</option>
	</select>
</div>

<!--Main Facility Info-->
<div class="MainGrid TopMargin">
	<h4 class="GridHeader">Main Facility Information</h4>

	<label>Facility Code:</label>
	<input
		[disabled]="IsLoading() == true"
		class="form-control InputWidth"
		type="text"
		placeholder="Short code/abbreviation of the facility"
		[(ngModel)]="FacilityCD"
	/>

	<label>Facility Name:</label>
	<input
		[disabled]="IsLoading() == true"
		class="form-control InputWidth"
		type="text"
		placeholder="Name of the facility (usually the same as the school's name)"
		[(ngModel)]="FacilityName"
	/>
</div>

<!--Address/Contact Info-->
<div class="MainGrid TopMargin">
	<h4 class="GridHeader">Address/Contact Information</h4>

	<label>Street Address:</label>
	<input [disabled]="IsLoading() == true" class="form-control InputWidth" type="text" placeholder="1st line of school's Address" [(ngModel)]="Street1" />

	<label>City:</label>
	<input
		[disabled]="IsLoading() == true"
		class="form-control InputWidth"
		type="text"
		placeholder="City where the school is located"
		[maxLength]="30"
		[(ngModel)]="City"
	/>

	<label>State:</label>
	<input
		[disabled]="IsLoading() == true"
		class="form-control InputWidth"
		type="text"
		placeholder="State abbreviation (Ex. PA, MD, etc.)"
		[maxLength]="2"
		[(ngModel)]="State"
	/>

	<label>Zip:</label>
	<input
		[disabled]="IsLoading() == true"
		class="form-control InputWidth"
		type="text"
		placeholder="Zip code (max 10 characters)"
		[maxLength]="10"
		[(ngModel)]="Zip"
	/>

	<label>Phone Number:</label>
	<input
		[disabled]="IsLoading() == true"
		class="form-control InputWidth"
		type="text"
		placeholder="School's Phone Number (can include or not include -'s)"
		[maxLength]="25"
		[(ngModel)]="WorkPhone"
	/>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button [disabled]="IsLoading() == true" class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
